import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import FormDialog from '../../../../components/FormDialog';
import ConfirmationDialog from '../../../../components/ConfirmationDialog';

const useStyles = makeStyles(() => ({
  root: {
    '& .MuiPaper-root': {
      width: 700,
      overflowY: 'visible'
    }
  }
}));

const CreateCustomBracketSetRequest = ({ disabled, bracketLibraries, proceed, cancel }) => {
  const [data, setData] = useState({
    name: null,
    notes: null,
    confirmed: null
  });
  const classes = useStyles();

  const createChangeHandler = name => ({ target }) => {
    setData(prev => ({ ...prev, [name]: target.value }));
  };

  const handleClose = response => {
    if (response) {
      proceed({
        custom_bracket_set_creation_request: {
          name: data.name,
          notes: data.notes
        }
      });
    } else {
      cancel();
    }
  };

  useEffect(() => {
    if (disabled || !bracketLibraries || bracketLibraries.length <= 1) {
      proceed();
    }
  }, [bracketLibraries, proceed, disabled]);

  if (!bracketLibraries) {
    return '';
  }

  const handleConfirmation = answer => {
    if (answer) {
      setData(prev => ({ ...prev, confirmed: true }));
    } else {
      proceed({});
    }
  };

  return (
    <>
      {data.confirmed === null && (
        <ConfirmationDialog
          open
          handleClose={handleConfirmation}
          title="Custom Bracket Set"
          confirmText="Yes"
          declineText="No"
          bodyText="Would you like to save this selection as a custom set of brackets?"
        />
      )}
      {data.confirmed === true && (
        <FormDialog
          open
          titleText=""
          acceptButtonText="Submit"
          declineButtonText="Cancel"
          handleClose={handleClose}
          className={classes.root}
          isAcceptButtonDisabled={!data.name}
        >
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Name of the Custom Set"
            type="text"
            value={data.name}
            onChange={createChangeHandler('name')}
            fullWidth
            multiline
            required
            variant="outlined"
          />
          <TextField
            minRows={5}
            margin="dense"
            id="notes"
            label="Notes"
            type="text"
            value={data.notes}
            onChange={createChangeHandler('notes')}
            fullWidth
            multiline
            variant="outlined"
          />
        </FormDialog>
      )}
    </>
  );
};

CreateCustomBracketSetRequest.propTypes = {
  bracketLibraries: PropTypes.arrayOf(PropTypes.shape({})),
  disabled: PropTypes.bool.isRequired,
  proceed: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired
};

CreateCustomBracketSetRequest.defaultProps = {
  bracketLibraries: null
};

export default CreateCustomBracketSetRequest;
